import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { Suspense, useEffect } from 'react';

import { PageLayout } from '~components/page/PageLayout';
import JobListComponent from '~extension/web2print/controller/JobListController';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import { selectAddonsIsWeb2PrintEnabled, selectAddonsIsWeb2PrintMaintenance } from '~store/selectors';
import MediaLibraryComponent from '../modules/media-library/controller/MediaLibraryController';

export default function Web2PrintPage() {
  const { hlPageWeb2Print, msgWeb2PrintMaintenance } = useLabels(['hlPageWeb2Print', 'msgWeb2PrintMaintenance']);
  const { hlPageWeb2PrintSub } = useLabels(['hlPageWeb2PrintSub']);
  const navigateToDefault = useNavigateToDefault();

  // read store values
  const isEnabled = useAppSelector(selectAddonsIsWeb2PrintEnabled);
  const isMaintenance = useAppSelector(selectAddonsIsWeb2PrintMaintenance);

  useEffect(() => {
    if (!isEnabled) {
      navigateToDefault();
    }
  }, [navigateToDefault, isEnabled]);

  if (isMaintenance) {
    return (
      <PageLayout title={hlPageWeb2Print} className="page--web2print">
        <div className="c-view__header u-margin-vertical-md u-padding-horizontal-xxl">
          <div className="o-grid o-grid--unpad o-grid--bottom">
            <div className="o-grid__cell o-grid__cell--width-10 w2p-header">
              <h2>{hlPageWeb2Print}</h2>
              <p dangerouslySetInnerHTML={{ __html: msgWeb2PrintMaintenance }}></p>
            </div>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title={hlPageWeb2Print} className="page--web2print">
      <div className="c-view__header u-margin-vertical-md u-padding-horizontal-xxl">
        <div className="o-grid o-grid--unpad o-grid--bottom">
          <div className="o-grid__cell o-grid__cell--width-10 w2p-header">
            <h2>{hlPageWeb2PrintSub}</h2>
            <p>
              The Web2Print library gives you access to all templates that you can edit directly online without any
              background knowledge in graphic design.
            </p>
            <ul>
              <li>Create customized, brand-compliant, ready-to-print layouts.</li>
              <li>Manage your versioning under My Web2Print files (in progress) or My Web2Print files (done).</li>
              <li>
                Click <a href="/sites/default/files/1620973261/Linde_plc_Web2Print-Manual_052025.pdf">here</a> for a
                quick guide to the Web2Print library and the online editing options available to you.
              </li>
            </ul>
            <p>
              Please make sure to use one of the following browsers: Google Chrome (&gt;version 84.0.4147.135), Edge
              Chromium or Firefox. The tool does not work with Internet Explorer.
            </p>
          </div>
        </div>

        <div className="c-view__content relative flex-grow overflow-hidden w2p-content">
          <div className="h-full">
            <Suspense fallback="loading">
              <TabGroup>
                <TabList>
                  <Tab>Choose & edit Web2Print files</Tab>
                  <Tab>My Web2Print files (in progress)</Tab>
                  <Tab>My Web2Print files (done)</Tab>
                </TabList>
                <TabPanels>
                  <TabPanel>
                    <MediaLibraryComponent realm="web2print_library" />
                  </TabPanel>
                  <TabPanel>
                    <JobListComponent jobStatus="running" />
                  </TabPanel>
                  <TabPanel>
                    <JobListComponent jobStatus="finish" />
                  </TabPanel>
                </TabPanels>
              </TabGroup>
            </Suspense>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
